import { useQuery } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useHealthyRanges = () => {
	return useQuery({
		queryKey: ["healthy-ranges"],
		queryFn: () => EndpointsService.dataRetriever.getHealthyRanges(),
	});
};
